export default __webpack_public_path__ + "alberta-message.cfc4d9ccf3708435a847.svg";